var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCtaIconsExportCsv({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 26.003,
    viewBox: "0 0 15 26.003",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-20 -0.997)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.5 5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.5,3a1,1,0,0,1,1-1H15.75L19.5,5.75V21a1,1,0,0,1-1,1H5.5a1,1,0,0,1-1-1Z",
    fill: "#fff",
    className: "main"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.75,2,19.5,5.75H16.75a1,1,0,0,1-1-1Z",
    fill: "#ccc",
    className: "main"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.375,4.188a.312.312,0,0,1,.313-.312H8.563a.313.313,0,0,1,0,.625H6.688A.312.312,0,0,1,6.375,4.188Zm0,1.25a.312.312,0,0,1,.313-.312H9.813a.313.313,0,0,1,0,.625H6.688A.312.312,0,0,1,6.375,5.438Zm.313.938a.313.313,0,0,0,0,.625H9.813a.313.313,0,0,0,0-.625Z",
    fill: "#615e59",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.733,18.6a.979.979,0,0,1-.15.493.907.907,0,0,1-.386.33,1.3,1.3,0,0,1-.566.117,1.047,1.047,0,0,1-.828-.342,1.414,1.414,0,0,1-.3-.967V18.1a1.617,1.617,0,0,1,.135-.685,1.032,1.032,0,0,1,.394-.454,1.09,1.09,0,0,1,.593-.161,1.146,1.146,0,0,1,.78.256,1.006,1.006,0,0,1,.335.7H8.1a.477.477,0,0,0-.123-.35.5.5,0,0,0-.352-.106.384.384,0,0,0-.352.179,1.153,1.153,0,0,0-.117.573v.189a1.286,1.286,0,0,0,.106.61.394.394,0,0,0,.37.183.493.493,0,0,0,.339-.1.443.443,0,0,0,.125-.331Zm1.679.194a.263.263,0,0,0-.1-.22,1.223,1.223,0,0,0-.35-.163,3.369,3.369,0,0,1-.41-.163.777.777,0,0,1-.518-.7.627.627,0,0,1,.128-.39.832.832,0,0,1,.366-.264,1.409,1.409,0,0,1,.531-.1,1.237,1.237,0,0,1,.514.1.813.813,0,0,1,.355.293.758.758,0,0,1,.126.432h-.641a.321.321,0,0,0-.1-.253.386.386,0,0,0-.269-.09.439.439,0,0,0-.273.077.231.231,0,0,0-.1.192.237.237,0,0,0,.11.187,1.42,1.42,0,0,0,.386.172,2.327,2.327,0,0,1,.454.191.763.763,0,0,1,.432.687.651.651,0,0,1-.264.549,1.173,1.173,0,0,1-.723.2,1.451,1.451,0,0,1-.588-.115.9.9,0,0,1-.4-.319.839.839,0,0,1-.132-.467H9.6a.414.414,0,0,0,.11.317.53.53,0,0,0,.361.1.414.414,0,0,0,.251-.068A.228.228,0,0,0,10.413,18.791Zm2.007-.017.531-1.941h.718l-.9,2.666h-.7l-.89-2.666h.712Z",
    fill: "#615e59"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M.76-12.2l3.675-3.675a.445.445,0,0,1,.63,0L8.74-12.2a.445.445,0,0,1-.315.76H5.789V-.008a.445.445,0,0,1-.445.445H4.156a.445.445,0,0,1-.445-.445v-11.43H1.075A.445.445,0,0,1,.76-12.2Z",
    transform: "translate(23 17)",
    fill: "#feba30",
    className: "arrow"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCtaIconsExportCsv);
export default __webpack_public_path__ + "static/media/ctaIcons_ExportCSV.5f1d7b09262ac1174e90ef47068dde58.svg";
export { ForwardRef as ReactComponent };